import { produce } from 'immer';

import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  EDITING_DOCUMENT__FIELD_CREATE,
  EDITING_DOCUMENT__TEXT_FIELD_CONTEXT_MENU_CHANGE,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';
import EditingDocumentFieldInformation from '@app/store/editingDocument/EditingDocumentFieldInformation';
import TextFieldChangeType from '@app/store/editingDocument/TextFieldChangeType';
import FieldType from '@app/store/FieldType';
import FontType from '@app/store/FontType';
import TextAlign from '@app/store/TextAlign';

export interface EditingDocumentFieldInformationState {
  [uuid: string]: EditingDocumentFieldInformation;
}

const initialState: EditingDocumentFieldInformationState = {};

export default function reducer(
  state: EditingDocumentFieldInformationState = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FIELD_CREATE:
      return produce(state, (draft) => {
        const { meta, information } = action.payload;
        const { uuid } = meta;
        draft[uuid] = information;

        const targetTextField = draft[uuid];
        if (targetTextField.fieldType === FieldType.TEXT_FIELD) {
          if (!targetTextField.fontFamily) {
            targetTextField.fontFamily = FontType.NOTO_SANS;
          }
          if (!targetTextField.fontSize) {
            targetTextField.fontSize = 12;
          }

          /**
           * 필드 생성할 때 텍스트 정렬 기본값은 왼쪽(LEFT)입니다.
           */
          targetTextField.textAlign = TextAlign.LEFT;
        }
      });
    case EDITING_DOCUMENT__TEXT_FIELD_CONTEXT_MENU_CHANGE:
      return produce(state, (draft) => {
        const { changedType, inputId, value } = action.payload;

        const targetTextField = draft[inputId];
        if (
          changedType === TextFieldChangeType.FONT_FAMILY &&
          targetTextField.type === FieldType.TEXT_FIELD
        ) {
          targetTextField.fontFamily = value as FontType;
        }

        if (
          changedType === TextFieldChangeType.FONT_SIZE &&
          targetTextField.type === FieldType.TEXT_FIELD
        ) {
          targetTextField.fontSize = Number(value);
        }

        if (
          changedType === TextFieldChangeType.TEXT_ALIGN &&
          targetTextField.type === FieldType.TEXT_FIELD
        ) {
          targetTextField.textAlign = value as TextAlign;
        }

        if (
          changedType === TextFieldChangeType.VALUE &&
          targetTextField.type === FieldType.TEXT_FIELD
        ) {
          targetTextField.value = String(value);
        }
      });
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    default:
      return state;
  }
}
